import { useState } from 'react'

import { CardType } from 'types/deck'

import { Tab as TabType, generateTabState } from 'types/searchV2'

import Icon from 'components/elements/Icon'
import SearchV2Standalone from 'components/cardSearchPanel/searchV2Standalone'

import styles from './oTags.module.scss'

type Props = {
  card: CardType
  onTagClicked?: () => void
}

const OTags = ({ card, onTagClicked }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <h3>Oracle tags</h3>

        <div className={styles.tags}>
          {card.oTags.map((tag, index) => (
            <OTag tagName={tag} onTagClicked={onTagClicked} key={index} />
          ))}
        </div>
      </div>

      <div>
        <h3>Inherited tags</h3>

        <div className={styles.tags}>
          {card.inheritedTags.map((tag, index) => (
            <OTag tagName={tag} onTagClicked={onTagClicked} key={index} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default OTags

type OTagProps = {
  tagName: string
  onTagClicked?: () => void
}

const OTag = ({ tagName, onTagClicked }: OTagProps) => {
  const [searchTab, setSearchTab] = useState<TabType>()

  const handleTagClick = () => {
    const tagSlug = tagName.replace(/ /g, '-')
    const newTab = generateTabState.scrySearch()

    // @ts-ignore
    newTab.meta.query = `otag:${tagSlug}`

    if (onTagClicked) onTagClicked()

    setSearchTab(newTab)
  }

  return (
    <>
      <button onClick={handleTagClick} className={styles.tag}>
        <Icon name="tag" /> {tagName}
      </button>

      <SearchV2Standalone
        header={`Tag: ${tagName}`}
        open={!!searchTab}
        searchTab={searchTab}
        onClose={() => setSearchTab(undefined)}
      />
    </>
  )
}
